<template>
  <div class="schedule">
    <ReportDraftWatermark v-if="report.is_draft" />
    <h2 class="formTitle">Schedule C: Corrections</h2>
    <v-divider></v-divider>
    <C4ScheduleCReceipts :report="report"/>
    <C4ScheduleCExpenses :report="report"/>
    <C4ScheduleCRefunds :report="report"/>
  </div>
</template>

<script>
import filters from "../filters";
import utils from "./report-utils";
import C4ScheduleCExpenses from "./C4ScheduleCExpenses";
import C4ScheduleCReceipts from "./C4ScheduleCReceipts";
import C4ScheduleCRefunds from "./C4ScheduleCRefunds";
import ReportDraftWatermark from "@/components/ReportDraftWatermark.vue";

export default {
  name: "ScheduleC",
  components: {C4ScheduleCRefunds, C4ScheduleCReceipts, C4ScheduleCExpenses, ReportDraftWatermark},
  props: {
    report: Object
  },
  data() {
    return {}
  },
  methods: {
    ...filters.filters, ...utils
  },
  created() {
    this.sortByDate(this.report.user_data.contribution_corrections);
  }
}
</script>

<style scoped>.schedule { position: relative; }</style>
